import { Component } from '@angular/core';
import { TwoColumnLayoutComponent } from '../../components/two-column-layout/two-column-layout.component';
import { DashboardService } from '../../services/dashboard.service';

@Component({
    selector: 'chassis-core-dashboard-page',
    templateUrl: './dashboard.page.html',
    styleUrls: ['./dashboard.page.scss']
})
export class DashboardPage {

    /**
     * The layout to use.
     *
     * @type {TwoColumnLayoutComponent}
     */
    public layout = TwoColumnLayoutComponent;

    constructor(public service: DashboardService) {
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/pages/dashboard/dashboard.page.ts